import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";

import useAddGLEntity from "./hooks/useAddGLEntity";
import useGLEntity from "./hooks/useGLEntity";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { addStateGLEntity, setFilterTextGLEntity } from "./atoms/atoms";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import { useQueryClient } from "react-query";

const GLEntityForm = () => {
  //Hooks
  const { mutateAsync: AddGLEntity } = useAddGLEntity();
  const { data } = useGLEntity();
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateGLEntity);

  const [, setFilterText] = useRecoilState(setFilterTextGLEntity);
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasGLEntity, setHasGLEntity] = useState(false);
  const queryClient = useQueryClient();

  const defaulValues = {
    glentityId: 0,
    glentityName: "",
    createdBy: "",
    createdDate: null,
    isActive: 0,
    glnumber: "",
  };
  const [emptypeNewData, setNewData] = useState([defaulValues]);
  const [error, setError] = useState("");

  const validateGLNumber = (glnumber, glentityName, setError, setChanged) => {
    const num = Number(glnumber);

    if (num >= 10000 && num <= 29999) {
      setError("Value must be between 1-9999 or 30000 above.");
      setChanged(false);
      return false;
    } else if (glnumber && glentityName) {
      setChanged(true);
      setError("");
      return true;
    }
    setError("");
    setChanged(true);
    return true;
  };

  const handleAddGLEntity = (sourceType, fieldName, inputvalue) => {
    const trimmedValue = inputvalue.trim();
    if (sourceType !== "addGLEntity") return;

    // Update fields immutably
    const updatedData = emptypeNewData.map((x) => ({
      ...x,
      [fieldName]: trimmedValue,
      isActive: true,
    }));
    setNewData(updatedData);

    const { glentityName, glnumber } = updatedData[0];

    // Check for duplicates
    const duplicate = data?.some(
      (item) =>
        item.glentityName.toUpperCase() === glentityName.toUpperCase() &&
        item.glnumber === Number(glnumber)
    );

    if (duplicate) {
      setHasGLEntity(false);
      setChanged(false);
      return;
    }

    setHasGLEntity(true);

    // Validate values
    if (glnumber) {
      validateGLNumber(glnumber, glentityName, setError, setChanged);
    } else {
      setChanged(false);
      setError("");
    }
  };

  //save changes
  const handleSave = (emptypeNewData) => {
    setOpenModal(false);
    if (actionAddState) {
      AddGLEntity(emptypeNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModal(false);
          } else {
            setActionAddState(false);
            setNewData([defaulValues]);
            queryClient.invalidateQueries(["GetGLEntitys"]);
            toast.fire("Success", "GL Entity Added Successfully", "success");
            setOpenModal(false);
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Add GL Entity", "error");
          queryClient.invalidateQueries(["GetGLEntitys"]);
        },
      });
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "GL Number",
      field: "glnumber",
      render: (rowData) => {
        return (
          <div className="flex flex-col cursor-pointer">
            <TextInput
              type="number"
              placeholder="GL Number"
              defaultValue={rowData.glnumber}
              onChange={(inputdata) => {
                handleAddGLEntity(
                  "addGLEntity",
                  "glnumber",
                  inputdata.target.value
                );
              }}
            />
            {error && (
              <p className="text-xs text-red-500 mt-1 italic">{error}</p>
            )}
          </div>
        );
      },
    },
    {
      title: "GL Entity Name",
      field: "glentityName",
      render: (rowData) => {
        return (
          <div className="w-full ">
            <div className="">
              <TextInput
                defaultValue={rowData.glentityName}
                onChange={(e) =>
                  handleAddGLEntity(
                    "addGLEntity",
                    "glentityName",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="animate-fade-in-down">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add GL Entity"
          qConfirmation="Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(emptypeNewData);
          }}
        />
        <div className="p-3  space-y-1 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold ">
              Add New GL Entity
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <SaveButton
                className={`flex items-left shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasGLEntity || !changed ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasGLEntity || !changed}
                onClick={() => setOpenModal(true)}
              />
              <CancelButton
                className="flex items-left text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClick={() => {
                  setActionAddState(!actionAddState);
                  setFilterText("");
                }}
              />
            </div>
          </div>

          <div className="mt-2 h-0.5 w-full border-b-2 border-secondary mb-5"></div>

          <div className="py-1"></div>

          <div className="space-y-5 space-x-2 space-y-20 w-full  ">
            <MaterialExTable
              columns={matcolumns}
              data={emptypeNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="pb-1.5"></div>
        </div>
      </div>
    </div>
  );
};

export default GLEntityForm;
